module.exports = __webpack_public_path__ + "img/merbear_lemon_black_raspberry.ba272cde.png";